import { Cartesian3 } from "cesium";
import { EarthBrainUtils } from "./earthbrainutility";
export var PathUtils;
(function (PathUtils) {
    function computeStraightLine(startPoint, endPoint, stepSize) {
        return EarthBrainUtils.getLinearInterpolation(startPoint, endPoint, stepSize, true, true);
    }
    PathUtils.computeStraightLine = computeStraightLine;
    function _computeBezierPoints(p1, p2, p3, section, stepSize) {
        const result = [];
        if (section === "start") {
            const midPoint = Cartesian3.multiplyByScalar(Cartesian3.add(p1, p2, new Cartesian3()), 0.5, new Cartesian3());
            const startPoints = computeStraightLine(p1, midPoint, stepSize);
            // Since the last segment might be smaller than the interpolation pitch
            // Removing the point as the this segment will be merged with the first point in the bzier curve
            // const lastPoint = startPoints.pop();
            // Calculating the length of the straight line which should be merged with the first point in the bezier curve
            // const distBeforeTheCurve =
            //     startPoints.length > 0 ? Cartesian3.distance(startPoints[startPoints.length - 1], lastPoint) : 0;
            // First half of this bezier curve. Includes mid point (last in the array) of the curve
            const firstHalf = EarthBrainUtils.calculateCurvePathPointForSegment([p1, p2, p3], stepSize, true);
            // All the points from first till last here will be equidistant except last.
            // Last point is the mid point of the bezier curve
            result.push(...startPoints);
            result.push(...firstHalf);
        }
        else if (section === "end") {
            // Second half of the bezier curve. Starts at the mid point, points contain the midpoint (first in the array) of the curve
            const secondHalf = EarthBrainUtils.calculateCurvePathPointForSegment([p1, p2, p3], stepSize, false);
            // Since the last segment might be smaller than the interpolation pitch
            // Removing the point as the this segment will be merged with the first point in the start line ahead
            const lastPoint = secondHalf.pop();
            const distBeforeTheStraight = secondHalf.length > 0
                ? Cartesian3.distance(lastPoint, secondHalf[secondHalf.length - 1])
                : 0;
            const offsetDist = stepSize - distBeforeTheStraight;
            const midPoint = Cartesian3.multiplyByScalar(Cartesian3.add(p2, p3, new Cartesian3()), 0.5, new Cartesian3());
            const firstPointOnStraight = EarthBrainUtils.getDistantCartesianOnALine(midPoint, p3, offsetDist);
            const endPoints = computeStraightLine(firstPointOnStraight, p3, stepSize);
            // All the points from first till last here will be equidistant except last.
            // First point is the Mid point of the bezier curve
            result.push(...secondHalf);
            result.push(...endPoints);
        }
        return result;
    }
    function computeBezierCurve(points, stepSize, section) {
        let result = [];
        if (!(points.length === 3 || points.length == 4)) {
            console.warn("Points length should be 3 or 4 but received ", points.length);
            return result;
        }
        if (points.length === 3) {
            result = _computeBezierPoints(points[0], points[1], points[2], section, stepSize);
        }
        else if (points.length === 4) {
            if (section === "start") {
                result = _computeBezierPoints(points[0], points[1], points[2], section, stepSize);
            }
            else if (section === "end") {
                result = _computeBezierPoints(points[1], points[2], points[3], section, stepSize);
            }
            else if (section === "mid") {
                // First Half of this segment is the later half of bezier curve in following points
                // Mid point of the curve is included in the points
                const firstHalf = EarthBrainUtils.calculateCurvePathPointForSegment(points.slice(0, 3), stepSize, false);
                // Last segment here will be smaller than the interpolation pitch hence merging with start segment of the next bezier curve
                // const lastPoint = firstHalf.pop();
                // const distBeforeSecondHalf = Cartesian3.distance(lastPoint, firstHalf[firstHalf.length - 1]);
                // Second half of this segment is the first half of bezier curve in following points
                // Last point in this curve should be a start point of the next segment
                const secondHalf = EarthBrainUtils.calculateCurvePathPointForSegment(points.slice(1), stepSize, true);
                // All of the points should be equidistant at interpolation distance
                result.push(...firstHalf);
                result.push(...secondHalf);
            }
        }
        //
        //validitycheck
        for (let i = 0; i < result.length - 1; ++i) {
            if (Cartesian3.equals(result[i], result[i + 1])) {
                console.warn("duplicated point", i);
                result.splice(i + 1, 1);
                --i;
            }
        }
        return result;
    }
    PathUtils.computeBezierCurve = computeBezierCurve;
    /**
     * Utility function to compute the cumulative distance from first path point to a point
     * @param localPoint Cartesian3 in local space.
     * @param pathPoints Cartesian3[] Path points
     * @returns number Distance from first path point
     */
    function computeDistanceFromStartToPointOnCenterLine(localPoint, pathPoints) {
        let distanceFromStart = 0;
        for (let pathPointIndex = 1; pathPointIndex < pathPoints.length; pathPointIndex++) {
            const distanceFromPathPointToPoint = Cartesian3.distance(pathPoints[pathPointIndex - 1], localPoint);
            const distanceBtwPathPoints = Cartesian3.distance(pathPoints[pathPointIndex - 1], pathPoints[pathPointIndex]);
            if (distanceFromStart + distanceBtwPathPoints >=
                distanceFromStart + distanceFromPathPointToPoint) {
                distanceFromStart += distanceFromPathPointToPoint;
                break;
            }
            distanceFromStart += distanceBtwPathPoints;
        }
        return distanceFromStart;
    }
    PathUtils.computeDistanceFromStartToPointOnCenterLine = computeDistanceFromStartToPointOnCenterLine;
    function getPointsInCircleArc(center, radius, start, end, normal, interpolationPitch) {
        const result = [];
        result.push(start);
        let loopPoint = start;
        const dirToLoop = Cartesian3.subtract(loopPoint, center, new Cartesian3());
        while (Cartesian3.distance(loopPoint, end) > interpolationPitch) {
            const dirToNext = new Cartesian3();
            Cartesian3.cross(dirToLoop, normal, dirToNext);
            Cartesian3.normalize(dirToNext, dirToNext);
            const nextPoint = Cartesian3.multiplyByScalar(dirToNext, interpolationPitch, new Cartesian3());
            Cartesian3.add(loopPoint, nextPoint, nextPoint);
            Cartesian3.subtract(nextPoint, center, dirToLoop);
            Cartesian3.normalize(dirToLoop, dirToLoop);
            const adjustedNextPoint = Cartesian3.multiplyByScalar(dirToLoop, radius, new Cartesian3());
            Cartesian3.add(center, adjustedNextPoint, adjustedNextPoint);
            result.push(adjustedNextPoint);
            loopPoint = adjustedNextPoint;
        }
        result.push(end);
        return result;
    }
    PathUtils.getPointsInCircleArc = getPointsInCircleArc;
    function generateThreePointArc(p1, p2, p3, interpolationPitch, startPoint, endPoint) {
        const v1 = Cartesian3.subtract(p1, p2, new Cartesian3());
        const v2 = Cartesian3.subtract(p3, p2, new Cartesian3());
        const normal = Cartesian3.cross(v1, v2, new Cartesian3());
        Cartesian3.normalize(normal, normal);
        const v2Ortho = Cartesian3.cross(v2, normal, new Cartesian3());
        Cartesian3.normalize(v2Ortho, v2Ortho);
        const halfV2 = Cartesian3.multiplyByScalar(v2, 0.5, new Cartesian3());
        const fullangle = Cartesian3.angleBetween(v1, v2);
        const halfV1Length = Math.sqrt(v1.x ** 2 + v1.y ** 2 + v1.z ** 2) / 2;
        const halfV2Length = Math.sqrt(halfV2.x ** 2 + halfV2.y ** 2 + halfV2.z ** 2);
        // Just computing tan(angle) here after some algebraic manipulation
        const k = halfV2Length / halfV1Length;
        const tanAngle = (1 - k * Math.cos(fullangle)) / (k * Math.sin(fullangle));
        const bisectorLength = halfV2Length * tanAngle;
        const vecToCenter = Cartesian3.add(halfV2, Cartesian3.multiplyByScalar(v2Ortho, bisectorLength, new Cartesian3()), new Cartesian3());
        const center = Cartesian3.add(p2, vecToCenter, new Cartesian3());
        // EarthBrainUtils.createLineEntity(viewer, "Test", [center, p2], { color: Color.RED, outlineColor: Color.BLACK, outlineWidth: 0.2, width: 2 });
        //center test
        const radius = Cartesian3.distance(center, p1);
        const d2 = Cartesian3.distance(center, p2);
        const d3 = Cartesian3.distance(center, p3);
        console.log("distance should be same", radius, d2, d3);
        return getPointsInCircleArc(center, radius, startPoint, endPoint, normal, interpolationPitch);
    }
    PathUtils.generateThreePointArc = generateThreePointArc;
    /**
     *  p1 and p2 will always be symmetric with respect to the line passing through pAnchor and center
     * @param p1
     * @param p2
     * @param pAnchor
     * @returns
     */
    function getCenterAndRadiusfromTwoPointsAndAnchorPoint(p1, p2, pAnchor) {
        // orthogonals from p1 and p2 will intersect at center
        const v1 = Cartesian3.subtract(p1, pAnchor, new Cartesian3());
        const v2 = Cartesian3.subtract(p2, pAnchor, new Cartesian3());
        const normal = Cartesian3.cross(v1, v2, new Cartesian3());
        Cartesian3.normalize(normal, normal);
        const v2Ortho = Cartesian3.cross(v2, normal, new Cartesian3());
        Cartesian3.normalize(v2Ortho, v2Ortho);
        // angle between the two vectors
        const fullangle = Cartesian3.angleBetween(v1, v2);
        const tangentLength = Cartesian3.distance(p2, pAnchor);
        const radius = tangentLength * Math.tan(fullangle / 2);
        const center = Cartesian3.add(p2, Cartesian3.multiplyByScalar(v2Ortho, radius, new Cartesian3()), new Cartesian3());
        return { center, radius };
    }
    PathUtils.getCenterAndRadiusfromTwoPointsAndAnchorPoint = getCenterAndRadiusfromTwoPointsAndAnchorPoint;
})(PathUtils || (PathUtils = {}));
//# sourceMappingURL=path-utils.js.map